/**
 * @deprecated Import from '@/components/atoms' or '@/atoms' instead.
 * This file is kept for backwards compatibility during migration.
 */

export { Skeleton } from '@/components/atoms/feedback';
